import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_PRODUCT_CATEGORY_FAIL = "SHOP:UPSERT_PRODUCT_CATEGORY_FAIL";

export const upsertProductCategoryFailAction = (
  organization: OrganizationKeyName,
  errors: AdminErrorListResponseData,
  id?: string
) => ({
  type: UPSERT_PRODUCT_CATEGORY_FAIL as typeof UPSERT_PRODUCT_CATEGORY_FAIL,
  organization,
  errors,
  id,
});

export type UpsertProductCategoryFailAction = ReturnType<
  typeof upsertProductCategoryFailAction
>;
